module.exports = require("./../../_gen/starling/filters/ColorMatrixFilter");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/filters/ColorMatrixFilter.js
// module id = 200
// module chunks = 0